import {
  ADD_PREMIUM_TO_CART_API_REQUEST,
  ADD_PREMIUM_TO_CART_API_SUCCESS,
  ADD_PREMIUM_TO_CART_API_ERROR,
  ADD_PREMIUM_TO_CART_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function addPremiumToCartApiRequest() {
  return {
    type: ADD_PREMIUM_TO_CART_API_REQUEST,
    payload: true,
  };
}

function addPremiumToCartApiSuccess(localCart, cart, params) {
  return {
    type: ADD_PREMIUM_TO_CART_API_SUCCESS,
    payload: cart,
    local: localCart,
    params,
  };
}

function addPremiumToCartSuccess(cart, params) {
  return {
    type: ADD_PREMIUM_TO_CART_API_SUCCESS,
    payload: cart,
    params,
  };
}

function addPremiumToCartApiError(err) {
  return {
    type: ADD_PREMIUM_TO_CART_API_ERROR,
    payload: err,
  };
}

export function addPremiumToCartAction(localCartItem, params) {
  return (dispatch, getState) => {
    const state = getState();
    // const { isAuthenticated } = state.auth;
    // if (!isAuthenticated) {
    //  return dispatch(addPremiumToCartSuccess(localCartItem, params));
    // }
    dispatch(addPremiumToCartApiRequest());
    return cartApi
      .addPremiumToCart(state, params)
      .then(data => {
        dispatch(addPremiumToCartApiSuccess(localCartItem, data, params));
        return data;
      })
      .catch(error => {
        dispatch(addPremiumToCartApiError(error));
        throw error;
      });
  };
}

export default { addPremiumToCartAction };
